module.exports = __webpack_public_path__ + "static/media/starbridge-white.1de6c163.png";